module.exports = __webpack_public_path__ + "img/woohooo.f89a7e62.svg";